<app-navigation tagline="DATENSCHUTZ" marginLeftClass="ml-40"></app-navigation>
<ion-content>
  <div class="ion-margin slide white policy">
<h1>Datenschutz</h1>
<p>
  Alle Nutzungsdaten (d. h. Deine Antworten auf die Fragen bzw. Aussagen) werden ausschließlich lokal generiert und gespeichert und zu keinem Zeitpunkt über das Internet übertragen.
</p>
<p>
  Deine Nutzungsdaten kannst Du im Browser z. B. folgendermaßen löschen:
</p>
<p>
  <b>Google Chrome</b>: Wähle „Einstellungen“ > „Datenschutz und Sicherheit“ > „Browserdaten löschen“, markierte „Cookies und Websitedaten“ und tippe auf „Daten löschen“.
</p>
<p>
  <b>Safari</b>: Um den Verlauf und die Cookies zu löschen, gehe zu „Einstellungen“ > „Safari“, und tippe auf „Verlauf und Websitedaten löschen“.
</p>
<p>
  <b>Mozilla Firefox</b>: Wähle „Einstellungen“ > „Datenschutz & Sicherheit“ > „Cookies und Website-Daten“ und tippe auf „Daten entfernen“.
</p>
<p>
  <b>Microsoft Edge</b>: Wähle „Einstellungen“ > „Cookies und Websiteberechtigungen“ > „Verwalten und löschen von Cookies und Websitedaten“ > „Alle Cookies und Websitedaten anzeigen” und tippe auf „Alle entfernen“.
</p>
<h4>Fragen zum Datenschutz im Zusammenhang mit dieser App beantwortet </h4>
<p>
  E-Mail: <a href="mailto:orientando@wm.bwl.de">orientando&#64;wm.bwl.de</a><br>
</p>
  <p>Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg ist erreichbar per</p>

<p>
  E-Mail: <a href="poststelle@lfdi.bwl.de">poststelle&#64;lfdi.bwl.de</a><br>Telefon: 0711 6155410<br>
</p>
</div>

</ion-content>
<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-title class="footer">#ORIENTANDO</ion-title>
  </ion-toolbar>
</ion-footer>

